import { render, staticRenderFns } from "./DataContent.vue?vue&type=template&id=5f609a63&scoped=true&"
import script from "./DataContent.vue?vue&type=script&lang=js&"
export * from "./DataContent.vue?vue&type=script&lang=js&"
import style0 from "./DataContent.vue?vue&type=style&index=0&id=5f609a63&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f609a63",
  null
  
)

export default component.exports